import { Vehicle as _Vehicle } from '../../../shared-models/public/vehicle';

export class Vehicle extends _Vehicle {
}

export namespace Vehicle {
    export import RestTypes = _Vehicle.RestTypes;
}